// extracted by mini-css-extract-plugin
module.exports = {"container":"__5mmJmrQJ","text":"McaPkseI","checkbox":"BmgNQbxm"};